import PropTypes from "prop-types";
import { calculatePercent } from "./reportHelpers";
import { TD, TR } from "./BusinessDashboard/Table/Table";

const TableData = ({ total, value }) => (
  <TD>
    <strong>{value}</strong>
    {total >= 0 && <span style={{ fontSize: "13px" }}> ({calculatePercent(total, value).toFixed(0)}%)</span>}
  </TD>
);

TableData.propTypes = {
  total: PropTypes.number.isRequired,
  value: PropTypes.string.isRequired,
};

const AgentReportTotalRow = ({
  total_leads: totalLeads,
  total_emails: totalEmails,
  total_calls: totalCalls,
  total_contacted: totalContacted,
  total_texts: totalTexts,
  total_logins: totalLogins,
}) => (
  <TR className="tw-sticky tw-bottom-0 tw-bg-white">
    <TableData value="Totals" />
    <TableData value={totalLeads} />
    <TableData value={totalEmails} total={totalLeads} />
    <TableData value={totalCalls} total={totalLeads} />
    <TableData value={totalContacted} total={totalLeads} />
    <TableData value={totalTexts} total={totalLeads} />
    <TableData />
    <TableData />
    <TableData />
    <TableData value={totalLogins} />
    <TD />
  </TR>
);

AgentReportTotalRow.propTypes = {
  total_leads: PropTypes.number.isRequired,
  total_emails: PropTypes.number.isRequired,
  total_calls: PropTypes.number.isRequired,
  total_contacted: PropTypes.number.isRequired,
  total_texts: PropTypes.number.isRequired,
  total_logins: PropTypes.number.isRequired,
};

export default AgentReportTotalRow;
